import { render, staticRenderFns } from "./wiki-help-link.vue?vue&type=template&id=550ce6ca"
import script from "./wiki-help-link.vue?vue&type=script&lang=js"
export * from "./wiki-help-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports